import { render, staticRenderFns } from "./termsBlue.vue?vue&type=template&id=687b56ee"
import script from "./termsBlue.vue?vue&type=script&lang=js"
export * from "./termsBlue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports